import { ActionTree } from 'vuex';
import ApiUrl from '../../../../api/url';
import { NodeDomainAccountState } from './types';
import { RootState } from '../../../types';
import * as types from './mutation-types';
import { AppContext } from '../../../context';
const MessageKey = AppContext.MessageKey;
import { translator } from '../../../translator';
import { isHappenedOtherPartyError } from '../../../error-type';

export const actions: ActionTree<NodeDomainAccountState, RootState> = {
    /**
     * ノード紐付きドメインアカウント一覧取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} id ノードID
     * @param {any} pageNumber ページ番号
     * @param {any} perPage ページ毎の表示件数
     * @returns {Promise<void>}
     */
    async search({ dispatch, commit }, { id, pageNumber, perPage, sort } = {}) {
        const requestParams = {
            page_number: pageNumber,
            per_page: perPage,
            'sort[column]': sort.column,
            'sort[direction]': sort.direction,
        };
        const nodeId = id;
        try {
            commit(types.SEARCH_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.Node.DomainAccount.SEARCH.replace(':id', nodeId.toString()),
                    params: requestParams,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SEARCH_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.SEARCH_FAILURE, resData.errors[0]);
        }
    },

    /**
     * ドメインアカウント追加前のエラー等のクリア
     * 作成に失敗していた場合などに、そのままエラーメッセージなどVuex上に残っていたらクリアするため
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async newAccounts({ commit }) {
        commit(types.NEW_ACCOUNTS);
    },

    /**
     * ドメインアカウント追加
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} rootState Vuex変数
     * @param {any} node_id ノードID
     * @param {any} domain_account 追加するドメインアカウント情報
     * @returns {Promise<void>}
     */
    async create({ dispatch, commit, rootState }, { node_id, domain_account }) {
        try {
            commit(types.CREATE_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'post',
                    url: ApiUrl.Node.DomainAccount.CREATE.replace(':id', node_id.toString()),
                    params: { domain_account },
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.CREATE_SUCCESS);

                // 成功トースト表示
                const i18n = (rootState as any).i18n;
                const message = translator(i18n, MessageKey.Node.DomainAccount.CREATED);
                dispatch('toastMessage', message, { root: true });
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.CREATE_FAILURE, params);
        }
    },

    /**
     * ドメインアカウント除外
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} rootState Vuex変数
     * @param {any} node_id ノードID
     * @param {any} domain_account 除外するドメインアカウント情報
     * @returns {Promise<void>}
     */
    async destroy({ dispatch, commit, rootState }, { node_id, domain_account }) {
        try {
            commit(types.DESTROY_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'delete',
                    url: ApiUrl.Node.DomainAccount.DESTROY.replace(':id', node_id.toString()),
                    params: { domain_account },
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.DESTROY_SUCCESS);

                // 成功トースト表示
                const i18n = (rootState as any).i18n;
                const message = translator(i18n, MessageKey.Node.DomainAccount.DESTROYED);
                dispatch('toastMessage', message, { root: true });
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.DESTROY_FAILURE, params);
        }
    },

    /**
     * 画面切り替え時のstoreの消去
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async clearOnBeforeRoute({ commit }) {
        commit(types.CLEAR_ALL);
    },
};
